import { lt, showSuccessAlert } from '@mews/framework';

export const copyToClipboard = (value: string) => {
    const input = document.createElement('textarea');
    input.value = value;
    document.body.appendChild(input);

    input.select();
    const result = document.execCommand('copy');
    document.body.removeChild(input);

    return result;
};

export function copyInputToClipboard(value: string) {
    const success = copyToClipboard(value);

    if (success) {
        showSuccessAlert({ title: lt('CopiedSuccessMessage') });
    }
}
